import React, { useContext, useEffect } from 'react';
import StockHandler from '../Services/StockService';
import { CartContext } from '../Context/CartContext';
import { navigate, Link  } from "gatsby"
import { useGlobalDispatch, useGlobalState } from '../Context/globalContext';
import CartHandler from '../Services/CartService';
import { isLoggedIn } from '../Services/auth';
import {convertDate} from '../Helpers/index';


const CartCheckout = (props) => {
  let cartTotal = 0;
  const context = useContext(CartContext);
  
  const globalDispatch = useGlobalDispatch();
  const { member } = useGlobalState();
  
  if(!props?.license) {
    const { cartData, orderItem} = context?.state;
    orderItem.map((cartItem) => {
      cartTotal = +(cartItem.total_price.number) + cartTotal;  
    });
    cartTotal =  ( parseInt( cartTotal * 1000 ) / 1000 ).toFixed(2);
  }


  const addLicenseProductToCart = async () => {
    const authenticated = await isLoggedIn("membership");
    if(authenticated) {  
      const {variationId, quantity} = props;
      const response = await CartHandler.addCartItem(variationId, quantity);
      if (response) {
        globalDispatch({type: 'cart', payload: {'cart': response}});
        navigate("/checkout/cart", {state: {'order': response[0].order_id, 'storeLocation': props.storeLocation, 'orderdata': response }});
      }
    } else {
      navigate("user/login", {state: {message: "membership"}})
    }
     
  }

  // Check for multiple variations
  const checkStockValue = async () => {
    const stock = [];
    let outOfStock = false;
    const { cartData, orderItem } = context?.state;
    orderItem.map((cartItem) => {
      stock.push(cartItem.purchased_entity.variation_id);
    });
    const value = JSON.stringify(stock);
    const stockValue = await StockHandler.getStockValue(value);
    context.dispatch({ type: 'stockValue', stock: stockValue });
    if (stockValue) {
      for (let i = 0; i < orderItem.length; i++) {
        let { quantity } = orderItem[i];
        let { variation_id } = orderItem[i].purchased_entity;
        if (stockValue[variation_id] < 1 || stockValue[variation_id] < quantity) {
          outOfStock = true;
          break;
        }
      }

      if (!outOfStock) {
        navigate("/checkout/cart", {state: {'order': cartData[0].order_id, 'storeLocation': props, 'orderdata': orderItem }});
      }
    }
    globalDispatch({type: 'cart', payload: {'cart': orderItem}});
  };

  return (
    <div className="cart-checkout">
      {props?.license ?
      (
        <div className="cart-page-buttons">
        <button type="button" onClick={() => addLicenseProductToCart()}> Checkout</button>
        </div> 
      ) : (
        <>
        <div className="cart-checkout-total">
        <h4 className="title-28">Shopping Bag Total</h4>
        <div className="cart-total-wrapper">
          <div className="cart-total">
            <span>Sub total</span>
            <span>${cartTotal}</span>
          </div>
        </div>
        <div className="cart-page-buttons">
          <Link to="/products">Shop more</Link>
            <button type="button" onClick={() => checkStockValue()}> Checkout</button>
        </div>
      </div>
      <div className="cart-checkout-delivery text-center">
        {
          (member && member === 'unlimited') && (
            <>
            <p className="cart-product-name text-xl">Enjoy free delivery!</p>
            <div className>*Your are a member. To cancel the membership visit the <Link to="/user/orders">order page</Link></div>
            </>
          )}
          {(member && member !== 'unlimited') && (
                <>
                  <div>
                  <span className="title-24">Your License will expire on {(member && member?.expires) && new Date(member?.expires).toDateString()}</span>
                  </div>
                </>
          )}
          {
            (!member) &&
            (
              <>
              <h4 className="title-24">Get FREE delivery for a month.</h4>
              <Link className="button-green" to="/membership">Become a member now!</Link>
              </>
          )}
      </div>
      </>
      )
     
      }
    </div>
  );
};
export default CartCheckout;
